export const REQUEST_PROFILE_HEADER_INFO_ITEMS_LOADING_ITEMS_LENGTH = 5
